const DEFAULT_PAGE_COUNT = 30;

const STATE_MAP = {
    'P': '정상',
    'W': '대기',
    'WE': '대기(연장)',
    'WU': '대기(수정)'
};

const TYPE_MAP = {
    '001': '저장하기',
    '002': '자동완성',
    '003': '키워드검색'
};

export { DEFAULT_PAGE_COUNT, STATE_MAP, TYPE_MAP };